// File Name: pages/terms-and-policy-pages/LegalPageShell.js
//
// Shared frame for the YNO app's legal pages (/app/privacy, /app/terms,
// /app/delete-account).
//
// These render OUTSIDE the marketing site's header, footer and chatbot (see
// App.js): they are opened from inside the app and by app-store reviewers, who
// came for the document and nothing else. That also means this component owns
// its own page padding — it cannot borrow the site <main>'s.

import React from "react";
import { Typography, Layout, Divider } from "antd";
import { Link } from "react-router-dom";

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

export const APP_LEGAL_EFFECTIVE_DATE = "25 September 2026";
export const APP_LEGAL_CONTACT = "ibralisyed@gmail.com";

const LegalPageShell = ({ title, subtitle, children }) => (
  // minHeight covers the viewport: with no site chrome behind it, a short
  // document would otherwise leave the browser's default background showing.
  <Layout style={{ background: "#fff", minHeight: "100vh" }}>
    <Content
      style={{
        // Generous on desktop, tight on a phone — most readers arrive here by
        // tapping a link inside the app.
        padding: "clamp(24px, 5vw, 60px) clamp(18px, 6vw, 80px)",
        maxWidth: 900,
        margin: "0 auto",
        width: "100%",
      }}
    >
      {/* Minimal wordmark. Not the site header — just enough that a reviewer
          landing here cold can see whose document this is. */}
      <div style={{ marginBottom: 28 }}>
        <Link
          to="/"
          style={{
            fontSize: 22,
            fontWeight: 800,
            letterSpacing: -0.5,
            color: "#0C0F0A",
            textDecoration: "none",
          }}
        >
          YN<span style={{ color: "#9BB800" }}>O</span>
        </Link>
        <div
          style={{
            fontSize: 10,
            fontWeight: 700,
            letterSpacing: 1.6,
            textTransform: "uppercase",
            color: "#8B948F",
            marginTop: 2,
          }}
        >
          Yalla Nellab
        </div>
      </div>

      <Title level={2} style={{ marginBottom: 6 }}>
        {title}
      </Title>
      {subtitle ? (
        <Paragraph type="secondary" style={{ marginBottom: 20 }}>
          {subtitle}
        </Paragraph>
      ) : null}

      <Typography>
        <Paragraph>
          <Text strong>Effective Date:</Text> {APP_LEGAL_EFFECTIVE_DATE}
        </Paragraph>
        {children}

        <Divider />
        <Paragraph type="secondary" style={{ fontSize: 13 }}>
          This document covers the <Text strong>YNO mobile application</Text>. Our
          website and our in-person events are covered separately by the{" "}
          <Link to="/privacy">website Privacy Policy</Link> and the{" "}
          <Link to="/terms-and-conditions">website Terms of Use</Link>.
        </Paragraph>
      </Typography>
    </Content>
  </Layout>
);

export default LegalPageShell;
